export const TRANSFER_SCAN_SORTATION_CENTERS: string[] = [];
